<template>
  <div
    class="organism popular-plans pt-[76px] pb-[104px] px-2"
    :style="'background-color:' + organism.backgroundColor"
  >
    <h2
      class="font-archer text-gray-800 text-[40px] text-center max-w-xl mx-auto font-semibold mb-12 leading-none"
    >
      You may also be interested in these floor plans:
    </h2>
    <ul class="popular-item-group">
      <OrganismsProductGrid :organism="organism.items" type="floorplans" />
    </ul>
  </div>
</template>

<style>
.popular-plans {
  .popular-item-group {
    @apply flex gap-8 flex-wrap max-w-screen-xl mx-auto justify-center items-start;
  }

  article {
    @apply max-w-md m-0 p-0;

    header {
      @apply bg-white drop-shadow-lg m-0 gap-0 sm:gap-2 xl:gap-7;

      figure {
        @apply h-full;

        img {
          @apply h-full;
        }
      }

      .item-text {
        @apply px-2 md:px-0 py-4 pr-4 self-start;
      }
    }
  }

  .explore-button {
    @apply hidden;
  }
}
</style>

<script setup>
const props = defineProps({
  organism: Object,
});
</script>
